var map = {
	"./book.svg": "53f9",
	"./calendar.svg": "4fc4",
	"./casos.svg": "6903",
	"./chat.svg": "f592",
	"./clock.svg": "88d2",
	"./config.svg": "c90f",
	"./desktop.svg": "1edd",
	"./exit.svg": "2c94",
	"./finance.svg": "4fd1f",
	"./historico.svg": "9238",
	"./house.svg": "ef1a",
	"./importar-beneficiarios.svg": "143b",
	"./lifesupport.svg": "09cc",
	"./line-chart.svg": "3a99",
	"./person.svg": "2350",
	"./results.svg": "753c",
	"./search.svg": "bc7a",
	"./support.svg": "0d54"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2253";